import { Routes } from '@angular/router';
import { AuthGuard } from './helpers/auth.guard';
import { Role } from './enum/role';

export const routes: Routes = [
  {
    path: 'login',
    loadComponent: () =>
      import('./login/login.component').then((mod) => mod.LoginComponent),
    canActivate: [AuthGuard],
    data: { roles: [Role.None] }
  },
  {
    path: 'recover-password',
    loadComponent: () => import('./recover-password/recover-password.component').then(mod => mod.RecoverPasswordComponent),
    canActivate: [AuthGuard],
    data: { roles: [Role.None] },
  },
  {
    path: 'reset-password',
    loadComponent: () => import('./reset-password/reset-password.component').then(mod => mod.ResetPasswordComponent),
    canActivate: [AuthGuard],
    data: { roles: [Role.None] },
  },
  {
    path: '',
    loadComponent: () =>
      import('./Main/backendmain.component').then(
        (mod) => mod.BackendMainComponent
      ),
      canActivate: [AuthGuard],
      data: { roles: [Role.Admin] },
    children: [
      {
        path: 'crm',
        loadComponent: () => import('./crm/crm.component').then((mod) => mod.CRMComponent),
        canActivate: [AuthGuard],
        data: { roles: [Role.Admin] }
      },
      {
        path: 'extract',
        loadComponent: () => import('./extract/extract.component').then((mod) => mod.ExtractComponent),
        canActivate: [AuthGuard],
        data: { roles: [Role.Admin] }
      },
      {
        path: 'allads',
        loadComponent: () =>
          import('./AllAds/allads.component').then(
            (mod) => mod.AllAdsComponent
          ),
        canActivate: [AuthGuard],
        data: { roles: [Role.Admin] }
      },
      {
        path: 'allcentris',
        loadComponent: () =>
          import('./Centris/centris.component').then(
            (mod) => mod.AllCentrisComponent
          ),
        canActivate: [AuthGuard],
        data: { roles: [Role.Admin] }
      },
      {
        path: 'allposter',
        loadComponent: () =>
          import('./Poster/poster.component').then(
            (mod) => mod.PosterComponent
          ),
        canActivate: [AuthGuard],
        data: { roles: [Role.Admin] }
      },
      {
        path: 'allbroker',
        loadComponent: () =>
          import('./Broker/broker.component').then(
            (mod) => mod.BrokerComponent
          ),
        canActivate: [AuthGuard],
        data: { roles: [Role.Admin] }
      },
      {
        path: 'alluser',
        loadComponent: () =>
          import('./Users/users.component').then((mod) => mod.UsersComponent),
        canActivate: [AuthGuard],
        data: { roles: [Role.Admin] }
      },
      {
        path: 'research',
        loadComponent: () =>
          import('./research/research.component').then((mod) => mod.ResearchComponent),
        canActivate: [AuthGuard],
        data: { roles: [Role.Admin] }
      },
      {
        path: 'statsaction',
        loadComponent: () =>
          import('./stats-action/stats-action.component').then((mod) => mod.StatsActionComponent),
        canActivate: [AuthGuard],
        data: { roles: [Role.Admin] }
      },
      {
        path: 'statsads',
        loadComponent: () =>
          import('./StatsAds/statsads.component').then(
            (mod) => mod.StatsAdsComponent
          ),
        canActivate: [AuthGuard],
        data: { roles: [Role.Admin] }
      },
      {
        path: 'volumeads',
        loadComponent: () =>
          import('./VolumeAds/volumeads.component').then(
            (mod) => mod.VolumeAdsComponent
          ),
        canActivate: [AuthGuard],
        data: { roles: [Role.Admin] }
      },
      {
        path: 'library',
        loadComponent: () =>
          import('./Library/backendlibrary.component').then(
            (mod) => mod.BackendLibraryComponent
          ),
        canActivate: [AuthGuard],
        data: { roles: [Role.Admin] }
      },
      {
        path: 'by-province',
        loadComponent: () =>
          import('./byProvince/byProvince.component').then(
            (mod) => mod.ByProvinceComponent
          ),
        canActivate: [AuthGuard],
        data: { roles: [Role.Admin] }
      },
      {
        path: 'news',
        loadComponent: () =>
          import('./news/news.component').then((mod) => mod.NewsComponent),
        canActivate: [AuthGuard],
        data: { roles: [Role.Admin] }
      },
      {
        path: '**',
        redirectTo: '',
        canActivate: [AuthGuard],
        data: { roles: [Role.Admin] }
      }
    ]
  }
];
